import classNames from 'classnames';
import { t } from 'ttag';

import { Image } from '@ui/Image';
import { Button } from '@ui/Button';
import { BannerPlacement } from '@hook/useAnimatedAppsBanner';
import { AnimatedPageBanner } from '@components/AnimatedPageBanner';

import appLogo from './images/app-logo.png';

import s from './AnimatedAppsPromotionBannerMobile.sss';

const BANNER_DATA_MAP = {
  [BannerPlacement.Main]: {
    title: () => t`Встановити додаток`,
    description: () => t`Зручно шукати речі, замовляти та спілкуватися з продавцями у додатку`,
    preview: null,
    url: 'https://app.adjust.com/1dciefln?campaign=mobile_main_category',
  },
  [BannerPlacement.Category]: {
    title: () => t`Встановити додаток`,
    description: () => t`Зручно шукати речі, замовляти та спілкуватися з продавцями у додатку`,
    preview: null,
    url: 'https://app.adjust.com/1dciefln?campaign=mobile_main_category',
  },
  [BannerPlacement.Profile]: {
    title: () => t`Встановити додаток`,
    description: () => t`Отримуйте миттєві сповіщення про нові речі продавців, на яких підписані`,
    preview: null,
    url: 'https://app.adjust.com/1dbb1qb4?campaign=mobile_seller_feed',
  },
};

interface Props {
  className?: string,
  isVisible?: boolean,
  placement: BannerPlacement,
  onClose: () => void,
}

export const AnimatedAppsPromotionBannerMobile: React.FC<Props> = ({
  className,
  isVisible = true,
  placement,
  onClose,
}) => {
  const {
    title,
    description,
    url,
  } = BANNER_DATA_MAP[placement];

  if (!isVisible) {
    return null;
  }

  return (
    (
      <AnimatedPageBanner
        rootClassName={classNames(s.rootTypeSimple, className)}
        containerClassName={s.bannerTypeSimple}
        isVisible={isVisible}
        onClose={onClose}
      >
        <div className={s.simpleBannerContent}>
          <Image
            className={s.simpleBannerImage}
            src={appLogo}
            width="52"
            height="52"
          />
          <div>
            <p className={s.simpleBannerTitle}>
              {title()}
            </p>
            <p className={s.simpleBannerDescription}>
              {description()}
            </p>
          </div>
        </div>
        <Button
          className={s.simpleBannerButton}
          theme="secondary"
          href={url}
          target="_blank"
          rel="noopener noreferrer nofollow"
          onClick={onClose}
        >
          {t`Завантажити`}
        </Button>
      </AnimatedPageBanner>
    )
  );
};
